export const SUPERREADER_SCOPE = 'gti-triage';

export const SUPPORT_CONTACT = 'Please contact the GME Threat Intelligence team.';

export const REQUEST_DETAILS_TEMPLATE_URL = 'https://t.corp.amazon.com/create/templates/3720553c-6559-43f8-871f-409e6564ebb8';

export const APP_HEADER_ID = 'app-header';

export const MAX_ATTACHMENTS = 10;

// pre-signed PUT is hard-rejected above 5 GiB
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024 * 1024;
